/**
 * This type is to ensure that either an id or an inventoryId is provided.
 * Please add other id's as needed.
 * So, if the id is provided, the inventoryId is optional, but when the objects id is not called id,
 * the inventoryId or any other named id present, that one is used.
 * The generic function getValidId will return the one of any valid id defined in WithId.
 * example, adding another id:
 * export type WithId = AtLeastOne<{ id?: string; inventoryId?: string; anotherId?: string }>;
 * and adding it to the idKeys:
 * export const idKeys = ["id", "inventoryId", "ipAddress"] as const;
 */

type AtLeastOne<T, Keys extends keyof T = keyof T> = Partial<T> &
  { [K in Keys]: Required<Pick<T, K>> }[Keys];

export type WithId = AtLeastOne<{ id?: string; inventoryId?: string; ipAddress?: string }>;
export const idKeys = ['id', 'inventoryId', 'ipAddress'] as const;
